module.exports = __webpack_public_path__ + "img/mind2.0726883f.png";